import { createApp } from "vue";
import "./style.css";
import App from "./App.vue";
import { createRouter, createWebHistory } from "vue-router";
import Landing from "./pages/Landing.vue";
import Stichting from "./pages/Stichting.vue";
import Vastgoed from "./pages/Vastgoed.vue";

const routes = [
  { path: "/", component: Landing },
  { path: "/vastgoed", component: Vastgoed },
  { path: "/stichting", component: Stichting },
  { path: "/:pathMatch(.*)*", name: "NotFound", component: Landing },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

createApp(App).use(router).mount("#app");

const splash = document.getElementById("splash");
if (splash) {
  splash.remove();
}
